<template>
    <div class="vehicle">
        <form class="vehicle__form">
            <div class="vehicle__groups">

                <div class="vehicle__group _big">

                    <v-select class="vehicle__select jlr-select"
                              :class="{ '_error': $v.vin.$error, '_searching': anotherVinChanged }"
                              ref="vinSelect"
                              v-if="savedVins.length"
                              placeholder="VIN"
                              :options="savedVins"
                              :taggable="true"
                              @search:blur="addAnotherVin"
                              @search:focus="autocompleteVin"
                              v-model="vin">
                    </v-select>

                    <input class="vehicle__input"
                           :class="{ '_error': $v.vin.$error }"
                           v-else
                           placeholder="VIN"
                           v-model.trim.lazy="vin"
                           @blur="$v.vin.$touch()"/>


                    <transition name="validation-error">
                        <div class="vehicle__errors"
                             v-if="$v.vin.$error">
                            <div class="validation-error"
                                 v-if="!$v.vin.required">
                                {{ $t('validations.required', { name: 'VIN' }) }}
                            </div>
                            <div class="validation-error"
                                 v-if="!$v.vin.isVin">
                                {{  $t('validations.isVin', { name: 'VIN'}) }}
                            </div>
                            <div class="validation-error"
                                 v-if="!$v.vin.maxLength || !$v.vin.minLength">
                                {{  $t('validations.lengthEqual',
                                { name: 'VIN', value: $v.vin.$params.maxLength.max })
                                }}
                            </div>
                        </div>
                    </transition>

                </div>

                <div class="vehicle__group">
                    <input class="vehicle__input _km"
                           :class="{ '_error': $v.mileage.$error }"
                           :placeholder="$t(`maintenance.mileage`) "
                           v-model.trim="mileage"
                           @blur="$v.mileage.$touch()"/>

                    <transition name="validation-error">
                        <div class="vehicle__errors"
                             v-if="$v.mileage.$error">
                            <div class="validation-error"
                                 v-if="!$v.mileage.required">
                                {{ $t('validations.required', { name: $t('maintenance.mileage') }) }}
                            </div>
                            <div class="validation-error"
                                 v-if="!$v.mileage.numeric">
                                {{ $t('validations.numeric', { name: $t('maintenance.mileage') }) }}
                            </div>
                            <div class="validation-error"
                                 v-if="!$v.mileage.maxLength && $v.mileage.numeric">
                                {{  $t('validations.maxLength',
                                { name: $t('maintenance.mileage'), value: $v.mileage.$params.maxLength.max })
                                }}
                            </div>
                            <div class="validation-error"
                                 v-if="!$v.mileage.minValue && $v.mileage.numeric">
                                {{  $t('validations.zeroValue', { name: $t('maintenance.mileage')}) }}
                            </div>
                        </div>
                    </transition>
                </div>

                <div class="vehicle__group _big">
                    <user-location class="user-location"
                                   :class="{ '_error': $v.location.$error }"
                                   :limitedСitiesList="cities"
                                   @changeUserLocation="setLocation($event)"
                                   @blur="$v.location.$touch()"/>

                    <transition name="validation-error">
                        <div class="vehicle__errors"
                             v-if="$v.location.$error">
                            <div class="validation-error"
                                 v-if="!$v.location.required">
                                {{ $t('validations.city') }}
                            </div>
                        </div>
                    </transition>

                </div>

            </div>

            <div class="vehicle__button">
                <submit-button @click="submit"
                               :sending="sending"/>
            </div>
        </form>
    </div>
</template>

<script>
    import { required, numeric, maxLength, minLength, minValue } from 'vuelidate/lib/validators'
    import { isVin } from '../validators/customValidators'
    import UserLocation from './UserLocation.vue'
    import vSelect from 'vue-select'

    export default {
        name: 'VehicleVinForm',
        props: {
            sending: {
                type: Boolean,
                required: true
            }
        },
        data() {
            return {
                vin: this.$store.state.clientVIN,
                mileage: this.$store.state.ClientMileage,
                location: '',
                savedVins: [],
                anotherVinChanged: false
            }
        },
        computed: {
            cities() {
                return this.$store.state.maintenance.cities;
            }
        },
        validations: {
            vin: {
                required,
                isVin,
                maxLength: maxLength(17),
                minLength: minLength(17)
            },
            mileage: {
                required,
                numeric,
                maxLength: maxLength(6),
                minValue: minValue(1)
            },
            location: {
                required
            }
        },
        methods: {
            addAnotherVin() {
                const searchValue = this.$refs.vinSelect.$refs.search.value;
                if (searchValue) {
                    this.vin = searchValue;
                }
                this.anotherVinChanged = false;
            },
            autocompleteVin() {
                let matches = 0;
                this.savedVins.forEach(savedVin => {
                    if (this.vin === savedVin) {
                        matches++;
                    }
                });

                if(!matches) {
                    this.anotherVinChanged = true;
                    setTimeout(() => {
                        this.$refs.vinSelect.$refs.search.value = this.vin;
                    }, 100)
                } else {
                    this.anotherVinChanged = false;
                }
            },

            setLocation($event) {
                this.location = $event;
            },

            submit() {
                this.$v.vin.$touch();
                this.$v.mileage.$touch();
                this.$v.location.$touch();

                if (!this.$v.$invalid) {
                    this.$emit('vinUpdated', {
                        vin: this.vin,
                        mileage: this.mileage
                    })
                }
            },
            getCookie(name) {
                var matches = document.cookie.match(new RegExp(
                    '(?:^|; )' + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)'
                ));
                return matches ? decodeURIComponent(matches[1]) : undefined;
            }
        },
        created() {
            const savedVins = this.getCookie('USER_VIN');
            if(savedVins) {
                savedVins.split(',').forEach(savedVin =>
                    this.savedVins.push(savedVin.trim())
                );
            }
        },
        beforeMount() {
            const infoInStore = this.$store.state.maintenanceSelected.vehicleInfo;
            if (infoInStore.mileage && this.$store.state.maintenanceSelected.vehicleInfoEntryType === 'vin') {
                this.mileage = infoInStore.mileage;
                this.vin = infoInStore.vin;
            }
        },
        components: {
            UserLocation,
            vSelect
        }
    }
</script>

<style lang="less" scoped>
    @import (less) '../styles/_media.less';
    @import (less) '../styles/colors.less';

    .vehicle {
        &__group {
            @media @tablet {
                width: 190px;
            }
            @media @desktop {
                width: 240px;
            }

            &._big {
                @media @tablet {
                    width: 250px;
                }
                @media @desktop {
                    width: 280px;
                }

                .vehicle__select {
                    width: 100%;
                }
            }
        }

        &__select {
            border: none;
            border-radius: 0;
            font-size: 10px;
            letter-spacing: 2px;
            width: inherit;

            &._searching {
                .selected-tag {
                    opacity: 0 !important;
                }

                .form-control {
                    letter-spacing: 2px;
                }
            }
        }
    }


</style>



// WEBPACK FOOTER //
// src/components/VehicleVinForm.vue